/**
 * Returns the Instagram username stored on a contact, if any.
 * Contacts may be camelized by the store, so both key styles are checked.
 */
export const getInstagramUsername = (contact = {}) => {
  const attrs =
    contact.additional_attributes || contact.additionalAttributes || {};
  const socialProfiles = attrs.social_profiles || attrs.socialProfiles || {};

  return (
    attrs.social_instagram_user_name ||
    attrs.socialInstagramUserName ||
    socialProfiles.instagram ||
    ''
  );
};

/**
 * Display name for conversation list/header.
 * Prefers @instagram_username when available so agents can identify IG clients.
 */
export const getContactDisplayName = (contact = {}, fallback = '') => {
  const username = getInstagramUsername(contact);
  if (username) {
    return `@${String(username).replace(/^@/, '')}`;
  }

  return contact.name || fallback || '';
};
